import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';

import Header from './components/external/header/header.vue'
import Login from './components/external/login/login.vue'
import Registration from './components/external/registration/registration.vue'
import Changelog from './components/external/changelog/changelog.vue'

Vue.use(VueRouter);
Vue.use(VueResource);

    // routing
var router = new VueRouter({
    routes: [
        { path: '/login', component: Login, name: 'login' },
        { path: '/registration', component: Registration, name: 'register' },
        { path: '/changelog', component: Changelog, name: 'changelog' },
        { path: '*', redirect: '/login' }
    ]
});


const app = new Vue({
	el: "#app",
	components: {
		'app-header': Header
	},
	router
});


// WEBPACK FOOTER //
// ./src/external.js